// 支付页面相关路由
// 商品选择
const CodeScanningPayment = r => require.ensure(
  [],
  () => r(require('@/components/codePayment/index.vue')),
  'CodeScanningPayment'
)
const Middlepage = r => require.ensure(
  [],
  () => r(require('@/components/codePayment/none.vue')),
  'Middlepage'
)
const payment = r => require.ensure(
  [],
  () => r(require('@/components/codePayment/payment.vue')),
  'CodeScanningPayment'
)
const ObjectSelect = r => require.ensure(
  [],
  () => r(require('@/components/Mpayment/object-select.vue')),
  'ObjectSelect'
)
// 订单创建
const orderCreate = r => require.ensure(
  [],
  () => r(require('@/components/Mpayment/order-create.vue')),
  'orderCreate'
)
// 退款信息
const refundInfo = r => require.ensure(
  [],
  () => r(require('@/components/Mpayment/refund-info.vue')),
  'refund-info'
)
// 支付成功
const payedSuccess = r => require.ensure(
  [],
  () => r(require('@/components/Mpayment/pay-success.vue')),
  'refund-info'
)

// 退款信息
const specialOrderRefund = r => require.ensure(
  [],
  () => r(require('@/components/Mpayment/special-refund')),
  'refund-info'
)

export default [
  // 支付条目选择页
  {
    path: '/ObjectSelect',
    name: 'ObjectSelect',
    component: ObjectSelect
  },
  {
    path: '/OrderCreate/:id',
    name: 'orderCreate',
    component: orderCreate
  },
  {
    path: '/RefundInfo/:id',
    name: 'refundInfo',
    component: refundInfo
  },
  {
    path: '/payedSuccess',
    name: 'payedSuccess',
    component: payedSuccess
  },
  {
    path: '/specialOrderRefund/:id',
    name: 'specialOrderRefund',
    component: specialOrderRefund
  },
  {
    path: '/CodeScanningPayment',
    name: 'CodeScanningPayment',
    component: CodeScanningPayment
  },
  {
    path: '/Middlepage',
    name: 'Middlepage',
    component: Middlepage
  },
  {
    path: '/Payment',
    name: 'Payment',
    component: payment
  }
  // CodeScanningPayment
]



// WEBPACK FOOTER //
// ./src/router/sub-route/Mpayment.js